export default __webpack_public_path__ + "static/media/Violet Blade.1abf115c.png";